import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import IntroductionPage from "./IntroductionPage/IntroductionPage";
import JoinRoomPage from "./JoinRoomPage/JoinRoomPage";
import RoomPage from "./RoomPage/RoomPage";
import { connectWithSocketIOServer } from "./utils/wss";
import { LocalVideoProvider } from "./context/localVideoManager";


import "./App.css";
import { ParticipantsProvider } from "./context/participantsContext";

require('dotenv').config()

function App() {


  useEffect(() => {
    connectWithSocketIOServer();
  }, []);

  return (
    <ParticipantsProvider>
    <LocalVideoProvider>
    <Router>
      <Switch>
        <Route path="/join-room">
          <JoinRoomPage />
        </Route>
        <Route path="/room">
          <RoomPage />
        </Route>
        <Route path="/">
          <IntroductionPage />
        </Route>
      </Switch>
    </Router>
    </LocalVideoProvider>
    </ParticipantsProvider>
  );
}

export default App;
